export default {
  id: 'user-journey',
  title: 'Your User Journey',
  content: `## Your User Journey

Here is what a typical progression looks like on TradeLab — from signing up to trading with full discipline.

---

## Day 1 — Setup

- Create your account
- Set your **Risk Profile** (account size, risk %, trading style)
- Read **What is TradeLab?** and **Modes Explained**
- Browse the **Learning Module** — start with Level 1

> Do not skip the Risk Profile. Every ACT score and position size suggestion depends on it.

---

## Week 1 — Learn the Platform

- Complete **ACT Practice** daily — 2 to 3 scenarios per session
- Browse **Scanners** to understand what setups look like
- Place 2 to 3 paper trades on the **Trade** page
- Check your **Discipline Score** after each trading day

---

## Week 2–4 — Build Habits

- Your **Behavioral Profile** starts forming after ~10 trades
- Review **Behavior Analytics** to spot patterns in your decisions
- Use **Nyx AI Coach** before placing trades — ask it to review your setup
- Run your first **Algo Flow** to automate a simple rule-based strategy

---

## Month 2 — Refine

- Use **Backtesting** to validate strategies before going live with them
- Read your **Trade Reports** — look at your win rate, average R:R, and behavioural flags
- Aim for a **Discipline Score above 70** consistently before considering real capital

---

## The TradeLab Readiness Benchmark

| Milestone | Target |
|---|---|
| ACT sessions completed | 50+ |
| Discipline Score | 70 or above consistently |
| Behavioral Profile | Disciplined or Methodical |
| Avg R:R on entered trades | 1.8 or above |
| Revenge trade count | 0 in last 30 days |

> Reaching these benchmarks does not guarantee success in live markets — but it means you have built the habits that give you the best possible foundation.

---

## Summary

TradeLab is not a race. The goal is to **slow down**, understand your own decision patterns, and build consistency. Every session — even a losing one — gives you data to improve.`,
};
